import * as THREE from 'three';
import { IGltfWallPoint } from '../../@types/Gltf';
import { scalePolygon } from './scalePolygon';

/**
 * Scales the corners of a room, represented as IWallPoints.
 *
 * @param {IGltfWallPoint[]} corners - The wall points containing the wall reference and their positions.
 * @param {number} factor - The scaling factor for the transformation.
 * @param {THREE.Vector3}  origin - The optional origin point from where the scaling will happen.
 * @returns {IGltfWallPoint[]} The scaled points.
 */
export const scaleRoomCorners = (
  corners: IGltfWallPoint[],
  factor: number,
  origin: THREE.Vector3 = new THREE.Vector3(0, 0, 0),
): IGltfWallPoint[] => {
  const points = corners.map((corner) => corner.point);
  const scaledPoints = scalePolygon(points, factor, origin);

  return corners.map((corner, index) => ({
    ...corner,
    point: scaledPoints[index],
  }));
};
